import { ShieldX } from 'lucide-react';

/**
 * Displayed when a user tries to access a feature they don't have permission for.
 * Use as the `fallback` prop of <PermissionGuard /> for in-page denial (no redirect).
 */
export function AccessDenied() {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-center">
      <ShieldX className="w-12 h-12 text-neutral-400 mb-4" aria-hidden />
      <h2 className="text-xl font-semibold text-neutral-900 mb-2">Accès refusé</h2>
      <p className="text-sm text-neutral-600 max-w-md">
        Vous n&apos;avez pas les droits nécessaires pour accéder à cette section.
        Contactez votre administrateur si vous pensez qu&apos;il s&apos;agit d&apos;une erreur.
      </p>
    </div>
  );
}
